import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { StoreUser } from './appSlice';
import { Arrangement } from '../types';

export const apiSlice = createApi({
	baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
	tagTypes: ['Arrangements', 'User'],

	endpoints: builder => ({
		getUser: builder.query<StoreUser, void>({
			query: () => '/user',
			providesTags: ['User']
		}),
		getArrangements: builder.query<Arrangement[], number>({
			query: userId => '/user/arrangements?userId=' + userId,
			providesTags: ['Arrangements']
		}),
		addNewArrangement: builder.mutation<void, { userId: number; arrangement: Arrangement }>({
			query: ({ userId, arrangement }) => ({
				url: '/user/arrangements',
				method: 'POST',
				body: { userId, arrangement }
			}),
			invalidatesTags: ['Arrangements']
		})
	})
});

export const { useGetArrangementsQuery, useAddNewArrangementMutation, useGetUserQuery } = apiSlice;
// builder.query<ReturnValueHere, ArgumentTypeHere>.
